import { IPaymentGuestRequest } from "models/paymentGuest/IPaymentGestRequest";
import {
  ICardBrandsInstallments,
  IPaymentLinkResponse,
  PixPaymentRequest,
  PixPaymentResponse,
  TicketGetResponse,
  TicketPostResponse,
  TicketRequest,
} from "models/paymentLink/IPaymentLinkResponse";
import { Api } from "../Api";

const PaymentLinkApi = () => {
  const api = Api();

  const getPaymentProduct = (paymentLinkId: string) => {
    return api.get<IPaymentLinkResponse>(
      `/mepaylink/GetLinkById/${paymentLinkId}`
    );
  };

  const getPaymentGuestSendPay = (
    paymentGuestRequest: IPaymentGuestRequest
  ) => {
    if (
      paymentGuestRequest.storeId === '0209d91b-58f4-0bd3-6152-159290c2f466' || //premium
      paymentGuestRequest.storeId === '53e5e585-6f4d-eab7-f739-516988cbdaf3' //DEV
    ) {
      return api.post<IPaymentLinkResponse>(`https://connect-api.meep.cloud/api/PayLink`, paymentGuestRequest);
    } else {
      return api.post<IPaymentLinkResponse>(`/PayLink`, paymentGuestRequest);
    }
  };

  const pixPayment = async (payRequest: PixPaymentRequest) => {
    const response = await api.post<PixPaymentResponse>("/public/Pix/", payRequest);
    return response.data;
  };

  const pixPaymentStatus = async (paymentId: string) => {
    const response = await api.get<PixPaymentResponse>(`/public/Pix/${paymentId}`);
    return response.data;
  };

  const ticketPayment = async (payRequest: TicketRequest): Promise<TicketPostResponse> => {
    const response = await api.post(
      `/third/pay/boleto`, payRequest
    );
    return response.data.Result;
  };

  const ticketPaymentStatus = async (paymentId: string): Promise<TicketGetResponse> => {
    const response = await api.get(
      `/third/pay/boleto/${paymentId}`
    );
    return response.data[0];
  };

  const getInstallments = (paymentLinkId: string, value: number) => {
    return api.get<ICardBrandsInstallments[]>(
      `/mepaylink/${paymentLinkId}/installments?value=${value}`
    );
  };

  return {
    getPaymentProduct,
    getPaymentGuestSendPay,
    pixPayment,
    pixPaymentStatus,
    ticketPayment,
    ticketPaymentStatus,
    getInstallments,
  };
};

export default PaymentLinkApi;